import { MarcacaoExameRequestModel } from '@models/gestao/marcacao-exame-request-model';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { MarcacaoExameModel } from '@models/gestao/marcacao-exame.model';
import { HelpConfig } from '@config/help-config';
import { BaseResourceService } from '@core/services/outros/base-resource.service';

@Injectable({
  providedIn: 'root',
})
export class MarcacaoExameService extends BaseResourceService<MarcacaoExameModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.MANAGEMENT_API}marcacaoexames`, injector);
  }


  cancel(id: number, comentario: string): Observable<MarcacaoExameModel> {
    return this._httpClient.post<MarcacaoExameModel>(`${this._url}/cancelar?id=${id}`, { id, comentario }
    );
  }

  downloadReport(id: number): Observable<string> {
    return this._httpClient.get<string>(`${this._url}/downloadrelatorio?id=${id}`);
  }

  downloadReportTable(params?: { [param: string]: any }): Observable<string> {
    return this._httpClient.get<string>(`${this._url}/downloadrelatoriotabela`, { params });
  }
}
